import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GetAppIcon from "@mui/icons-material/GetApp";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { FiltroReporteCoberturaVisitas } from "./FiltroReporteCoberturaVisitas";
import { ReporteCoberturaVisitasTabla } from "./ReporteCoberturaVisitasTabla";

const hoy = new Date();
const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().split("T")[0];
const fechaHoy = hoy.toISOString().split("T")[0];

// Reporte de Cobertura de Visitas — tabla agrupada por asesor con filtro de fecha inicio/fin +
// ADR/Sucursal y columnas de visitas por mes (Ene..Dic) + total. Conectado a
// ReportesCRM/ReporteCoberturaVisitas?fechainicio&fechafin&adr&sucursal.
export const CRM_ReporteCoberturaVisitas = () => {
  const history = useHistory();

  const [boxstate, setBoxState] = useBox({
    fechaInicio: primerDiaMes,
    fechaFin: fechaHoy,
    pv: { adr: [], sucursal: [] },
  });

  const [listado, setListado] = useState([]);
  const [permisos, setPermisos] = useState();
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

  const cargarReporte = ({ fechaInicio, fechaFin }) => {
    let adr = GetKey(boxstate.pv.adr, ["idadr"]);
    let sucursal = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    if (!adr) adr = "0";
    if (!sucursal) sucursal = "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ReportesCRM/ReporteCoberturaVisitas?fechainicio=${fechaInicio}&fechafin=${fechaFin}&adr=${adr}&sucursal=${sucursal}`)
      .then((result) => {
        setListado(Array.isArray(result?.listado) ? result.listado : []);
        setPermisos(result?.permisos);
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("COBERTURA DE VISITAS", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    cargarReporte({ fechaInicio: boxstate.fechaInicio, fechaFin: boxstate.fechaFin });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Descarga el Excel del reporte — ReportesCRM/ImprimirExcelReporteCoberturaVisitas.
  const onGeneraExcel = () => {
    let adr = GetKey(boxstate.pv.adr, ["idadr"]);
    let sucursal = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    if (!adr) adr = "0";
    if (!sucursal) sucursal = "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ReportesCRM/ImprimirExcelReporteCoberturaVisitas?fechainicio=${boxstate.fechaInicio}&fechafin=${boxstate.fechaFin}&adr=${adr}&sucursal=${sucursal}`)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${filename}.xlsx`;
        downloadLink.click();
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("COBERTURA DE VISITAS", JSON.stringify(error), "error");
      });
  };

  return (
    <div className="crm-main-screen">
      <LoaderScreen loader={loader} />
      <div className="crm-body">
        <div className="crm-page rca-screen">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button className="crm-btn-regresar" onClick={() => history.goBack()}>
                    <ArrowBackIcon /> Regresar
                  </button>
                  <FiltroReporteCoberturaVisitas onCargar={cargarReporte} boxState={boxstate} onBoxChange={setBoxState} permisos={permisos} />
                </div>
                <div className="crm-head-center">
                  <p className="crm-module-subtitle">Reportes</p>
                  <h1 className="crm-module-title">COBERTURA DE VISITAS</h1>
                </div>
                <div className="crm-head-right">
                  <button className="crmcs-btn-excel" onClick={onGeneraExcel}>
                    <GetAppIcon /> Excel
                  </button>
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>

            <div className="crm-home-wrapper rca-wrapper scroll">
              <ReporteCoberturaVisitasTabla listado={listado} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
